import { Box, Icon, Typography } from '@mui/material'
import ErrorItemChip from '../ErrorItemChip'
import { ProblematicType } from './ErrorInsightsThemeDrawer'

interface ProblematicCardProps {
  type: ProblematicType
  title: string
  data: {
    name: string
    error_charge?: number
    instances?: number
    orders?: number
  }[]
  loading?: boolean
  activeProblematic: { type: ProblematicType; name: string }
  onProblematicClick: (type: ProblematicType, name: string) => void
}

const ProblematicCard = ({ type, title, data, loading, activeProblematic, onProblematicClick }: ProblematicCardProps) => {
  return (
    <Box
      border="1px solid #E6E6E6"
      borderRadius="4px"
      p={2}
      display="flex"
      flexDirection="column"
      gap={1}
      height="100%">
      <Box
        display="flex"
        alignItems="center"
        gap={1}>
        <Icon sx={{ color: '#000', fontSize: '20px' }}>
          {type === 'theme' && 'label'}
          {type === 'item' && 'category'}
          {type === 'location' && 'museum'}
        </Icon>

        <Typography
          fontSize={12}
          color="#000"
          lineHeight="initial">
          {title}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        gap={0.5}>
        {loading
          ? [...Array(3)].map((_, index) => (
              <ErrorItemChip
                key={index}
                type={type}
                loading={loading}
              />
            ))
          : data.map((item, index) => (
              <ErrorItemChip
                key={index + item.name}
                type={type}
                error={item.name}
                errorCharge={item.error_charge}
                active={item.name === activeProblematic?.name && type === activeProblematic?.type}
                onClick={onProblematicClick}
              />
            ))}
      </Box>
    </Box>
  )
}

export default ProblematicCard
